import { categoriesResponseSelector } from '../../selectors/standort/categories';
import { shouldFetch } from '../../fetchStatus';
import { FETCH_CATEGORIES_FAILURE, FETCH_CATEGORIES_REQUEST, FETCH_CATEGORIES_SUCCESS } from '../../actionTypes';
import { apiClient } from '../../../helpers/apiHelperV2';
import { standortUrlSelector } from '../../selectors/url';

export const fetchCategoriesIfNeeded = () => {
    return async function (dispatch, getState) {
        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const categoriesResponse = categoriesResponseSelector(state);

        if (shouldFetch(categoriesResponse.status)) {
            dispatch({
                type: FETCH_CATEGORIES_REQUEST,
                payload: { standortUrl },
            });
            try {
                const res = await apiClient.get('/api/v1/Categories', { params: { standortUrl } });

                dispatch({
                    type: FETCH_CATEGORIES_SUCCESS,
                    payload: { standortUrl, categories: res.data.data },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_CATEGORIES_FAILURE,
                    payload: { standortUrl, error },
                });
            }
        }
    };
};
